import { render, staticRenderFns } from "./yesMarkdown.vue?vue&type=template&id=19b2ec96"
import script from "./yesMarkdown.vue?vue&type=script&lang=js"
export * from "./yesMarkdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports